import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/services/config.service';

@Component({
  selector: 'app-lsr-cro',
  templateUrl: './lsr_cro.component.html',
  styleUrls: ['./lsr_cro.component.css'],
  standalone: true
})
export class LsrCroComponent implements OnInit {

  emailus: string;
  constructor(private configService: ConfigService) {
  }

  ngOnInit() {
    this.configService.isConfigLoaded().subscribe(loaded => {
      if (loaded) {
        let configModel = this.configService.getConfigModel();
        this.emailus = configModel.getConfigkeyname('EmailUs');
      }
    });
  }
}
